import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Backdrop, Button, CircularProgress, Container } from "@mui/material";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { ref, child, get, getDatabase, set } from "firebase/database";
import GetAuth from "../../../GetAuth";

const ManageMap = () => {
	const form = useRef();
	const [info, setInfo] = useState();
	const [submitting, setSubmitting] = useState(false);
	const { register, handleSubmit, reset } = useForm({
		defaultValues: {
			map: "",
		},
	});
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	useEffect(() => {
		get(child(dbRef, "michelsonaristhyl")).then((snapshot) => {
			setLoad(snapshot.val());
			setInfo(snapshot.val()?.map);
			reset(snapshot.val()?.map);
		});
	}, [dbRef, reset]);

	const onSubmit = ({ map }) => {
		setSubmitting(true);
		const data = {
			map,
			submitTime: new Date().toLocaleString(),
		};
		set(child(dbRef, "michelsonaristhyl"), { ...load, map: data })
			.then(function (response) {
				setSubmitting(false);
				Swal.fire({
					icon: "success",
					title: "Your map updated Successfully",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	return (
		<Container sx={{ pt: 1 }} className='manageMap'>
			<Typography
				variant='h4'
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				Manage Map
			</Typography>
			<Typography sx={{ pb: 2 }} className='textColor'>
				Last changed in {info?.submitTime || "N/A"}
			</Typography>

			<form ref={form} onSubmit={handleSubmit(onSubmit)} method='post'>
				<Grid container spacing={3}>
					<Grid item md={12} sm={12} xs={12}>
						<TextField
							required
							name='map'
							label='Map Embed Code'
							fullWidth
							multiline
							rows={2}
							InputLabelProps={{
								shrink: true,
							}}
							{...register("map", { required: true })}
						/>
					</Grid>

					<Grid item md={12} sm={12} xs={12}>
						<iframe
							src={`${info?.map}`}
							title={"Google map"}
							style={{
								width: "100%",
								minHeight: "250px",
								border: "4px solid",
							}}
							className='borderColor'
							allowFullScreen=''
							loading='lazy'></iframe>
					</Grid>
					<Grid item md={12} sm={12} xs={12}>
						<Button
							type='submit'
							variant='contained'
							sx={{
								width: "100%",
								mb: 2,
								px: 3,
								border: "4px solid",
								fontWeight: "bold",
								borderRadius: "25px",
							}}>
							Update
						</Button>
					</Grid>
				</Grid>
			</form>
			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={submitting || !load}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default ManageMap;
